import { Banner } from './components/Banner/Banner';
import { Box } from './components/Box/Box';
import { CarruselBoxUp } from './components/CarruselBoxUp/CarruselBoxUp';
import { CarruselBoxDown } from './components/CarruselBoxDown/CarruselBoxDown';
import VideoGallery from './components/VideoGallery/VideoGallery';
import Sustentabilidad from './components/Sustentabilidad/Sustentabilidad';

export const HomeHaka = () => {
  return (
    <main>
      <Banner />
      <Box />
      <CarruselBoxUp />
      <CarruselBoxDown />
      <Sustentabilidad />
      <VideoGallery />
    </main>
  )
}
